import { useEffect, useState } from 'react';

/**
 * Custom hook for watching and returning inner window width
 */
export default function useWindowWidth() {
  const [width, setWidth] = useState();

  useEffect(() => {
    if (window.innerWidth !== width) {
      setWidth(window.innerWidth);
    }
    const listener = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [width]);

  return width;
}
